export default "__VITE_ASSET__BvJe8fye__"